import { VariationTypeEnum } from "@utilities/enums";
import { Product, Size, Variations } from "@utilities/types";

export const setProductVariation = (product: Product)=> {
    let initialVariation:Variations = { quantity: 0 };

    if(product?.variationType === VariationTypeEnum.BOTH){
        //@ts-ignore
        initialVariation = { colorSizeData: [] };
        //@ts-ignore
        product.variations.colorSizeData.forEach((variation) => {
            //@ts-ignore
            initialVariation.colorSizeData.push({
                color: variation.color,
                sizes: variation.sizes.map((size: Size) => ({
                    size: size.size,
                    quantity: 0,
                })),
            });
        })
    } else if(product?.variationType === VariationTypeEnum.COLOR){
        //@ts-ignore
        initialVariation = { colors: [] };
        //@ts-ignore
        product.variations.colors.forEach((variation) => {
            //@ts-ignore
            initialVariation.colors.push({
                color: variation.color,
                quantity: 0,
            });
        })
    } else if(product?.variationType === VariationTypeEnum.SIZE){
        //@ts-ignore
        initialVariation = { sizes: [] };
        //@ts-ignore
        product.variations.sizes.forEach((variation) => {
            //@ts-ignore
            initialVariation.sizes.push({
                size: variation.size,
                quantity: 0,
            });
        })
    }

    return initialVariation;
}
